import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  container: {
    justifyContent: 'space-between',
    margin: '10px 0',
    [theme.breakpoints.up('md')]: {
      margin: 0,
    },
  },
  item: {
    marginTop: 0,
    textAlign: 'left' as const,
    display: 'inline-block',
    verticalAlign: 'middle',
  },
  itemValue: {
    marginTop: 5,
    display: 'block',
    fontSize: 25,
    fontWeight: 300,
    [theme.breakpoints.down('xs')]: {
      marginTop: 2,
      fontSize: 18,
    },
  },
  loss: {
    color: theme.palette.red.color,
  },
  profit: {
    color: theme.palette.green.color,
  },
  amountCurrency: {
    fontSize: 16,
    fontWeight: 300,
    padding: '0 3px',
    [theme.breakpoints.down('xs')]: {
      fontSize: 12,
    },
  },
  amountValue: {
    fontSize: 25,
    fontWeight: 300,
    [theme.breakpoints.down('xs')]: {
      fontSize: 18,
    },
  },
  amountFraction: {
    fontSize: 16,
    fontWeight: 300,
    [theme.breakpoints.down('xs')]: {
      fontSize: 12,
    },
  },
  roiPercent: {
    fontSize: 16
  },
}))
